import checkComplaintDuration from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-complaints/actions/checkComplaintDuration.js';
import complaintDurationCustomValidation from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-complaints/actions/complaintDurationCustomValidation.js';
import initialize from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-complaints/actions/initialize.js';

export default {
    checkComplaintDuration,
    complaintDurationCustomValidation,
    initialize,
};